import { createContext, useContext } from "react"
import type { EventEmitter } from "fbemitter"
import type { BranchShowVO } from "@/api"

export type IMapContext = {
  toggleIndustryPoint: (isShow?: boolean | undefined) => void
  toggleBranchShow: (data: BranchShowVO) => void
  getBranchShow: () => BranchShowVO
  setViewState: (viewState: any) => void
  getViewState: () => any
  getScale: () => number
  emitter: EventEmitter
}

const MapContext = createContext<IMapContext>({} as IMapContext)

export function useMapValue() {
  return useContext(MapContext)!
}

export default MapContext
